// OPEN ALL EXTERNAL LINKS IN NEW TAB
function targetBlank() {
    var internal = location.host.replace("www.", "");
    internal = new RegExp(internal, "i");
    var a = document.getElementsByTagName('a'); // grab every link on the page
    for (var i = 0; i < a.length; i++) {
        var href = a[i].host; // set the host of shopify link
        if( !internal.test(href) ) { // make sure the href of a element in loop doesn't contain current site's host
            a[i].setAttribute('target', '_blank'); // if it doesn't, set attribute
        }
    }
};
// Run the function targetBlank()
targetBlank();


document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.template-index .theme__header');
  const headerWrapper = document.querySelector('.template-index .header__wrapper');
  const hero = document.querySelector('#shopify-section-template--24485638406417__section_video_BxK3Wy');

  if (!header || !hero || !headerWrapper) {
    console.warn('Header or hero section not found');
    return;
  }

  function getHeroHeight() {
    return hero.getBoundingClientRect().height || 0;
  }

  function updateHeader() {
    const heroHeight = getHeroHeight();

    console.log("scrolling");
    
    if (window.scrollY > heroHeight) {
        console.log("add bg");
      header.classList.add('has-bg');
      headerWrapper.classList.remove('header-transparent');
      headerWrapper.classList.add('header-solid');
    } else {
        console.log("remove bg");
      header.classList.remove('has-bg');
      headerWrapper.classList.add('header-transparent');
      headerWrapper.classList.remove('header-solid');
    }
  }

  // Initial check on load
  updateHeader();

  // Update on scroll and resize
  window.addEventListener('scroll', updateHeader);
  window.addEventListener('resize', updateHeader);
  
});